import { Box } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from '../../../../../common/intl';
import { MomentFormats, useDate } from '../../../../../common/utils/date';
import { DocumentRevision, SmartReferenceType } from '../../../../../state/ducks/documentRevisions/types';
import { documentVersionPath } from '../../../../document.revision/utils/paths';
import useStyles from './LHRDeviation.banner.styles';

interface Props {
  documentRevision: DocumentRevision
}

const LHRDeviationBanner: React.FC<Props> = ({ documentRevision }) => {
  const classes = useStyles();
  const { formatDisplayDate } = useDate();

  const deviationRef = documentRevision?.smartReferencesFrom?.find(
    ref => ref.active && ref.type === SmartReferenceType.DeviationAffectedLHR,
  );

  if (!deviationRef) {
    return null;
  }

  const { effectivityDateFrom, effectivityDateTo } = deviationRef.metadata;
  // show from the effective-from date on (YYYY-MM-DD, compared with today's GMT+0 date like the backend)
  if (effectivityDateFrom && moment.utc().format('YYYY-MM-DD') < String(effectivityDateFrom).slice(0, 10)) {
    return null;
  }

  const fromDate = formatDisplayDate(effectivityDateFrom, MomentFormats.BriefDate) ?? '';
  const toDate = formatDisplayDate(effectivityDateTo, MomentFormats.BriefDate) ?? '';

  const deviationDocRev = deviationRef.fromDocRev;
  const linkUrl = deviationDocRev?.id && deviationDocRev?.documentId
    ? documentVersionPath(deviationDocRev.id, deviationDocRev.documentId)
    : undefined;

  return (
    <Box className={classes.root}>
      <span>{translate('lhrDeviation.banner.applied')}</span>
      <span className={classes.regular}>
        {translate('lhrDeviation.banner.dates', { fromDate, toDate })}
      </span>
      {linkUrl && (
        <Link to={linkUrl} target="_blank" className={classes.linkBox}>
          <OpenInNew className={classes.icon} />
        </Link>
      )}
    </Box>
  );
};

export default LHRDeviationBanner;
